import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addTax({ dispatch, commit }, tax) {
    try {
      const { data } = await request.post('taxes', tax);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
